import React, {  useState, useEffect } from 'react';
import { Form, Row, Col } from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import Loader from '../components/Loader'
import axios from 'axios'
import Kvar from '../components/Kvar'
import {useSelector} from 'react-redux'
import { Map, GoogleApiWrapper, Marker} from 'google-maps-react';

const KvarScreen = (props) => {

  const [stubovi, setStubovi] = useState([])
  //const [stub, setStub] = useState({})
  const [card, setCard] = useState(false)
  const [kvarovi, setKvarovi] = useState([])
  const [num, setNum] = useState('')
  const [abr, setAbr] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [mesta, setMesta] = useState([])
  const [mesto, setMesto] = useState(null)
  const [isLoader, setIsLoader] = useState(false)
  const [info, setInfo] = useState('')

  const mapStyles = {
  //  width: '40vw',
    height: '40vw'
   // position: 'relative'
  }

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const iconBase =
    "http://maps.google.com/mapfiles/ms/icons/"

  useEffect(() => {
    if (mesto) {

      axios.get(`/api/stubovi/${mesto._id}`).then(item => {
        setIsLoader(false)
        setStubovi(item.data)})
    }
  }, [userInfo, mesto])

  const submitHandler = (e) => {
    e.preventDefault()
  }

  const onClickHandler = (k) => {
    setKvarovi([])
  //  setIsLoader(true)
    axios.get(`/api/stubovi/istorijaizvestaja/${k._id}`)
    .then(item => {
      if (item.data.length !== 0) {
        setKvarovi(item.data)
      } else {
        setInfo(`Na stubu broj ${k.Rbr} do sada nije prijavljen kvar`)
      }
    })

    setCard(true)
  }

  const searchHandler = (query) => {
    setIsLoading(true)
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token} `
      }
    }

    axios.get(`/api/mesta/?abr=${query}`, config).then(item => {
      setMesta(item.data)
      setIsLoading(false)
      
    })

  } 

  const filterBy = () => true

  return (
    <>
{isLoader && <Loader />}
{!mesto && <div>
  <h2 className='text-center'>Istorija kvarova</h2>
      <AsyncTypeahead 
      filterBy={filterBy}
      id='basic-example' 
      labelKey='naziv'
      isLoading={isLoading}
      minLength={3}
      onSearch={searchHandler}
      options={mesta}
      placeholder='Izaberi grad'
      renderMenuItemChildren={(mesto) => (
        <div onClick={() => {
          setMesto(mesto)
          setIsLoader(true)
        }}>
        <span>{mesto.naziv}</span>
        </div>
        
      )}
      />
    </div>}
    

      {mesto && !isLoader && <>
      <Form onSubmit={submitHandler} inline>
       
       <Form.Control type='text' name='q' onChange={(e) => setAbr(e.target.value)} placeholder='Pretrazi adresu' className='mr-sm-2 ml-sm-5'></Form.Control>
       <Form.Control type='text' name='p' onChange={(e) => setNum(e.target.value)} placeholder='Pretrazi broj' className='mr-sm-2 ml-sm-5'></Form.Control>
        
     </Form> 
     <Row style={{height: '40vw'}}>
      <Col md={6}>
      <Map
    zoom={mesto.zoom}
    google={props.google}
   // style={mapStyles}
    mapType='satellite'
    initialCenter={
      {
        lat: mesto.center.lat,
        lng: mesto.center.lon
      }
    }
  >
    {stubovi.filter(s => s.Adresa.toUpperCase().includes(abr.toUpperCase())).filter(f => f.Adresa.toUpperCase().split(' ').pop().includes(num.toUpperCase())).map(stub => (
      <Marker key={stub._id} position={{lat: stub.LAT, lng: stub.LON}} onClick={() => onClickHandler(stub)}  icon = {stub.svetiljka ? iconBase + 'green-dot.png' : iconBase + 'red-dot.png' } />
    )
    )}
  </Map>
      </Col>
      <Col md={1} text-center></Col>
      <Col md={5} text-center>
        <h4>Istorijat kvarova na stubu</h4>
        <br/>
       
        <Kvar kvarovi={kvarovi} card={card} info={info}/>

      </Col>
    </Row>
    </>
    }
     
  
    </>
  )
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyACV2yMJcx_aByY3PwY1b59WvppbM9_ovc'
})(KvarScreen);
